import { MarkChatUnread, PhotoLibrary } from '@mui/icons-material';
import { Divider, Hidden, IconButton, Stack, Typography } from '@mui/material';
import {
  GenCurrency,
  PhotoGalleryPopUp,
} from '@pinnacleautomotive/clarity-components';
import { useState } from 'react';
import ActionsByService from './ActionsByService';

export default function ServiceDetails({ service, orderType }) {
  const [openGallery, setOpenGallery] = useState(false);

  return (
    <>
      <PhotoGalleryPopUp
        open={openGallery}
        images={service.attachments}
        initialSlide={1}
        handleModalState={() => setOpenGallery(false)}
        isServicesModal={true}
        notes={service.notes}
      />
      <Stack
        key={service.vendorOrderServiceId}
        direction="row"
        width="100%"
        divider={<Divider orientation="vertical" flexItem />}
        alignItems="center"
        gap={{ xs: 1, md: 4 }}
      >
        <Stack
          direction={{ xs: 'column', sm: 'row' }}
          justifyContent="space-between"
          alignItems={{ xs: 'flex-start', sm: 'center' }}
          flexGrow={1}
          gap={{ xs: 1, md: 4 }}
        >
          <Typography variant="body2" flexGrow={1}>
            {service.name}{' '}
            <Hidden mdDown>
              (<GenCurrency value={service.price} />)
            </Hidden>
          </Typography>
          <Stack direction="row" gap={4}>
            <Typography variant="body2">x{service.quantity}</Typography>
            <Typography variant="body2" width="100px" textAlign="right">
              <GenCurrency value={service.amount} />
            </Typography>
          </Stack>

          <Stack width="80px" direction="row" gap={1}>
            {service.attachments && !!service.attachments.length && (
              <IconButton
                color="info"
                onClick={() => setOpenGallery(true)}
                size="small"
              >
                <PhotoLibrary />
              </IconButton>
            )}
            {service.notes && (
              <IconButton
                color="info"
                onClick={() => setOpenGallery(true)}
                size="small"
              >
                <MarkChatUnread />
              </IconButton>
            )}
          </Stack>
        </Stack>

        <ActionsByService service={service} orderType={orderType} />
      </Stack>
    </>
  );
}
